// extracted by mini-css-extract-plugin
export default {"container":"Display_container__Xjh6Z","img":"Display_img__53TDX"};